import DeleteBulkAction from './DeleteBulkAction';
export default DeleteBulkAction;